import {createLazyComponent} from 'helpers/createLazyComponent'
import React from 'react'


const MissalPageLazy = createLazyComponent(() => import('./MissalPage'))

const MissalPage = (props) => <MissalPageLazy {...props} />

export default MissalPage
